<template>
  <div class="aboutMenuBox">
    <div class="wrap">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        text-color="#545454"
        active-text-color="#d71820"
        :router=true
      >
        <el-menu-item :key="idx" :index="item.url" v-for="(item, idx) in menu" >
         <a v-if="item.url2" :href="item.url2" target="_blank">{{ item.name }}</a>
         <span v-else>{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: this.$route.path||'',
    };
  },
  props: ["menu"],
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
   created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.activeIndex = this.$route.path;
      }
    );
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },
};
</script>

<style lang="scss">
.aboutMenuBox {
      background-color: #f9f9f9;

  .el-menu {
    background-color: #f9f9f9;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
   
    font-weight: bold;
  }
  /* .is-active:hover{a{color: #d71820;}}
  .el-menu--horizontal>.el-menu-item a, .el-menu--horizontal>.el-menu-item a:hover{
    color:none
  } */
}
@media(max-width:750px){
  .aboutMenuBox{
    overflow-y:hidden!important;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    color:rgb(84, 84, 84)!important
  }
}
</style>